import { render, staticRenderFns } from "./RoleRemove.vue?vue&type=template&id=1f7a9b96&scoped=true&"
import script from "./RoleRemove.vue?vue&type=script&lang=js&"
export * from "./RoleRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7a9b96",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7a9b96')) {
      api.createRecord('1f7a9b96', component.options)
    } else {
      api.reload('1f7a9b96', component.options)
    }
    module.hot.accept("./RoleRemove.vue?vue&type=template&id=1f7a9b96&scoped=true&", function () {
      api.rerender('1f7a9b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Administrator/components/Role/RoleRemove.vue"
export default component.exports